export default {
    GroupSettings: {
        information: 'Group Information',
        name: 'Group Full Name',
        abbreviated: 'Group Abbreviation',
        ps1: 'Supports PNG/JPG format, and file size should not exceed 500KB',
        ps2: 'Supports .ico format, and file size should not exceed 200KB',
        ps3: 'Please enter the full name of the group',
        ps4: 'Please enter the group abbreviation',
        ps5: 'The length is between 1 and 60 characters',
    },
};
